module.exports = __webpack_public_path__ + "static/product2_1-9822f064eddc22550c3593d3336853f2.jpg";